// ASCII values of 'a' and 'z'.
const aCharCode = 'a'.charCodeAt(0);
const zCharCode = 'z'.charCodeAt(0);
const numLetters = zCharCode - aCharCode;

// Letter frequencies are stored in an array of 26 slots --- one slot per
// letter of the alphabet.
const FreqsArray = Uint32Array;
// A letter frequency array with all zero frequencies. Used for initializing
// and resetting other frequency arrays.
const zero = new FreqsArray(numLetters);

// Conversions between ASCII character codes and indices used in letter
// frequency arrays
function charCodeToIdx(charCode: number) { return charCode - aCharCode; }
function idxToCharCode(idx: number) { return idx + aCharCode; }

/**
 * Convert a letter frequency array to a letter frequency object.
 *
 * For example, [5, 3, ..., 0] becomes {a: 5, b: 3, ..., z: 0}.
 */
function freqsArrayToFreqsObj(freqsArray: Uint32Array): { [key: string]: number } {
  const freqsObj: { [key: string]: number } = {};
  for (let i = 0; i < numLetters; i += 1) {
    freqsObj[String.fromCharCode(idxToCharCode(i))] = freqsArray[i];
  }
  return freqsObj;
}

/**
 * Return a frequency array object whose keys are letters of the alphabet and
 * whose values are the number of words that have the given letter.
 *
 * Implementation assumes words are in the ASCII character set and the number
 * of word is fewer than 2^32.
 */
export function wordsToFreqs(words: string[]) {
  const freqs = new FreqsArray(zero);
  const freqsOfAWord = new FreqsArray(zero);
  let i;
  let j;

  for (i = 0; i < words.length; i += 1) {
    const word = words[i];

    // Determine how this single word contributes to the letter frequencies for
    // all the words. Because we care about counting the number of words that
    // have a given letter, we only count the first occurrence of a letter in a
    // word and not repeated occurrences.
    freqsOfAWord.set(zero);
    for (j = 0; j < word.length; j += 1) {
      freqsOfAWord[charCodeToIdx(word.charCodeAt(j))] = 1;
    }

    // Add this word's contribution to the total frequencies.
    for (j = 0; j < numLetters; j += 1) {
      freqs[j] += freqsOfAWord[j];
    }
  }

  return freqsArrayToFreqsObj(freqs);
}
